import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import {
	get_property_lands,
	get_property_houses,
	reset,
} from '../../features/property/propertySlice'
import Slider from 'react-slick'
import HomeCarousel from '../../components/general/homepage/HomeCarousel'
import { comma } from '../../utils/helper'
// import CampaignSlider from '../../components/CampaignSlider'
import estate2 from '../../assets/house2.png'
import icon_why from '../../assets/icon_why.svg'
import avatar from '../../assets/avatar.png'

const Homepage = () => {
	const dispatch = useDispatch()

	const { loading, propertyLands, propertyHouses } = useSelector(
		(state) => state.propertyGetTypes
	)

	const landArray =
		propertyLands && propertyLands.lands && propertyLands.lands.slice(0, 2)
	const houseArray =
		propertyHouses && propertyHouses.houses && propertyHouses.houses.slice(0, 2)
	console.log(houseArray)
	let propertyArray
	if (landArray && houseArray) {
		propertyArray = [...landArray, ...houseArray]
	}

	const settingsReviews = {
		dots: false,
		infinite: true,
		speed: 1500,
		slidesToShow: 3,
		arrows: false,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 9000,
		pauseOnHover: false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					initialSlide: 2,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	}

	const reviews = [
		{
			id: 1,
			image: avatar,
			name: 'John Doe',
			location: 'Lagos',
			body: 'Nice Company, I Bought My Property Without Any Hassle, I Will Recommend Them To Anyone Interested In Getting A Real Estate  Property',
		},
		{
			id: 1,
			image: avatar,
			name: 'Jane Doe',
			location: 'Lagos',
			body: 'Nice Company, I Bought My Property Without Any Hassle, I Will Recommend Them To Anyone Interested In Getting A Real Estate  Property',
		},
		{
			id: 1,
			image: avatar,
			name: 'John Doe',
			location: 'Lagos',
			body: 'Nice Company, I Bought My Property Without Any Hassle, I Will Recommend Them To Anyone Interested In Getting A Real Estate  Property',
		},
		{
			id: 1,
			image: avatar,
			name: 'Jane Doe',
			location: 'Lagos',
			body: 'Nice Company, I Bought My Property Without Any Hassle, I Will Recommend Them To Anyone Interested In Getting A Real Estate  Property',
		},
		{
			id: 1,
			image: avatar,
			name: 'John Doe',
			location: 'Lagos',
			body: 'Nice Company, I Bought My Property Without Any Hassle, I Will Recommend Them To Anyone Interested In Getting A Real Estate  Property',
		},
		{
			id: 1,
			image: avatar,
			name: 'Jane Doe',
			location: 'Lagos',
			body: 'Nice Company, I Bought My Property Without Any Hassle, I Will Recommend Them To Anyone Interested In Getting A Real Estate  Property',
		},
	]

	useEffect(() => {
		dispatch(get_property_houses())
		dispatch(get_property_lands())

		return () => {
			dispatch(reset())
		}
	}, [dispatch])

	return (
		<>
			<main className='homepage'>
				<HomeCarousel />

				<section className='section novi-background section-md text-center'>
					<div className='container'>
						<h3 className='text-uppercase font-weight-bold wow-outer'>
							<span className='wow slideInDown'>
								<span style={{ color: '#607D3B' }}>Popular</span>{' '}
								<span className='green_text'>properties</span>
							</span>
						</h3>
						<div className='row row-lg-50 row-35 offset-top-2'>
							{propertyArray &&
								propertyArray.map((e) => (
									<>
										<div key={e._id} className='col-md-6'>
											<article className='post-modern'>
												<Link
													className='post-modern-media'
													to={`/properties/${e.propertyType}/${e._id}`}
												>
													<img
														src={e.displayImage}
														alt={e.propertyName}
														style={{ objectFit: 'cover', height: '20rem' }}
													/>
												</Link>
												<div
													style={{
														backgroundColor: '#fff',
														boxShadow: '1px 3px 6px #eee',
														marginBottom: '2rem',
														padding: '0.2rem .8rem',
													}}
												>
													<h4 className='post-modern-title'>
														<Link
															className='post-modern-title'
															to={`/properties/${e.propertyType}/${e._id}`}
															style={{ fontWeight: '600' }}
														>
															{e.propertyName}
														</Link>
													</h4>
													<ul className='post-modern-meta mt-2'>
														<li
															className='pt-0 m-0'
															style={{ fontSize: '15px' }}
														>
															Price: &#8358;{comma(e.price)}
														</li>
													</ul>
													<p className='mt-2'>
														{e.description.substring(0, '70')}...
													</p>
												</div>
											</article>
										</div>
									</>
								))}
							<div className='col-md-12 wow-outer'>
								<Link
									className='button button-primary btn_showel button-winona button-md'
									to={`/properties`}
								>
									view More properties
								</Link>
							</div>
						</div>
					</div>
				</section>

				<section className='section novi-background section-lg bg-gray-100'>
					<div className='container'>
						<div className='row row-30'>
							<div className='col-sm-6 col-lg-4 wow-outer'>
								<article className='box-minimal'>
									<div className='box-chloe__icon novi-icon linearicons-user wow fadeIn'></div>
									<div className='box-minimal-main wow-outer'>
										<h4 className='box-minimal-title wow slideInDown'>
											Qualified Employees
										</h4>
										<p className='wow fadeInUpSmall'>
											Our team consists of more than 20 qualified and
											experienced real estate brokers and property managers
											ready to help you.
										</p>
									</div>
								</article>
							</div>
							<div className='col-sm-6 col-lg-4 wow-outer'>
								<article className='box-minimal'>
									<div
										className='box-chloe__icon novi-icon linearicons-bubble-text wow fadeIn'
										data-wow-delay='.1s'
									></div>
									<div className='box-minimal-main wow-outer'>
										<h4
											className='box-minimal-title wow slideInDown'
											data-wow-delay='.1s'
										>
											Free Consultations
										</h4>
										<p className='wow fadeInUpSmall' data-wow-delay='.1s'>
											Our acquaintance with a client always begins with a free
											consultation to find out what kind of property they are
											looking for.
										</p>
									</div>
								</article>
							</div>
							<div className='col-sm-6 col-lg-4 wow-outer'>
								<article className='box-minimal'>
									<div
										className='box-chloe__icon novi-icon linearicons-star wow fadeIn'
										data-wow-delay='.2s'
									></div>
									<div className='box-minimal-main wow-outer'>
										<h4
											className='box-minimal-title wow slideInDown'
											data-wow-delay='.2s'
										>
											100% Guaranteed
										</h4>
										<p className='wow fadeInUpSmall' data-wow-delay='.2s'>
											All the results that you get from our realtors are 100%
											guaranteed to offer you the best choice of properties
											throughout the USA.
										</p>
									</div>
								</article>
							</div>
						</div>
					</div>
				</section>

				<section className='section novi-background section-lg text-center'>
					<div className='container'>
						<h3 className='text-uppercase font-weight-bold wow-outer'>
							<span className='wow slideInDown green_text'>
								Residential property{' '}
								<span className='green_text'>categories</span>
							</span>
						</h3>
						<p>
							<span className='text-width-1'>
								At our agency, we work with various types of residential real
								estate property. You can find out more about our properties by
								browsing our website.
							</span>
						</p>
						<div className='row row-35 row-xxl-70 offset-top-2'>
							<div className='col-sm-6 col-lg-3'>
								<article className='thumbnail-light'>
									<Link className='thumbnail-light-media' to='#'>
										<img
											className='thumbnail-light-image'
											src={estate2}
											alt=''
											width='270'
											height='300'
										/>
									</Link>
									<h4 className='thumbnail-light-title green_text'>
										Single-Family Homes
									</h4>
								</article>
							</div>
							<div className='col-sm-6 col-lg-3'>
								<article className='thumbnail-light'>
									<Link className='thumbnail-light-media' to='#'>
										<img
											className='thumbnail-light-image'
											src={estate2}
											alt=''
											width='270'
											height='300'
										/>
									</Link>
									<h4 className='thumbnail-light-title green_text'>
										Townhouses
									</h4>
								</article>
							</div>
							<div className='col-sm-6 col-lg-3'>
								<article className='thumbnail-light'>
									<Link className='thumbnail-light-media' to='#'>
										<img
											className='thumbnail-light-image'
											src={estate2}
											alt=''
											width='270'
											height='300'
										/>
									</Link>
									<h4 className='thumbnail-light-title green_text'>
										Multi-Family Homes
									</h4>
								</article>
							</div>
							<div className='col-sm-6 col-lg-3'>
								<article className='thumbnail-light'>
									<Link className='thumbnail-light-media' to='#'>
										<img
											className='thumbnail-light-image'
											src={estate2}
											alt=''
											width='270'
											height='300'
										/>
									</Link>
									<h4 className='thumbnail-light-title green_text'>
										Condominiums
									</h4>
								</article>
							</div>
							<div className='col-md-12 wow-outer'>
								<Link
									className='button button-winona button-primary btn_showel button-md'
									to='properties'
								>
									view all properties
								</Link>
							</div>
						</div>
					</div>
				</section>

				{/* <CampaignSlider /> */}

				<section className='homepage_test'>
					<div className='container'>
						<h3 className='text-uppercase text-center font-weight-bold wow-outer'>
							<span className='wow slideInDown'>
								<span className='green_text'>Clients Testimonials</span>
							</span>
						</h3>
						<p className='text-center'>
							<span className='text-width-1'>
								We collect reviews from our customers
							</span>
						</p>

						<div className='row'>
							<Slider {...settingsReviews}>
								{reviews.map((e) => (
									<div key={e.id} className='homepage_test_box'>
										<div className='text-center'>
											<img src={e.image} alt='' />
											<h5> {e.name} </h5>
											<h6> {e.location} </h6>

											<p> {e.body} </p>
										</div>
									</div>
								))}
							</Slider>
						</div>
					</div>
				</section>
			</main>
		</>
	)
}

export default Homepage
